import { Button, ButtonProps } from './Button';

type Props = ButtonProps;
export function SecondaryButton(props: Props) {
    return <Button {...props} variant="secondary" />;
}
